<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Dokumentáció verziók</span>
      <el-button
        v-can="'docversion.create'"
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="$router.replace('/doc-versions/add')"
      >
        Új verzió
      </el-button>
    </div>
    <docVersion-list />
    <template v-if="$route.meta.showAddDocVersionDialog">
      <DocVersionDialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateDocVersionDialog">
      <DocVersionDialog
        :doc-version-id="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
  import DocVersionDialog from '../components/docVersions/Dialog';
  import DocVersionList from '../components/docVersions/List';

  export default {
    components: {
      DocVersionDialog,
      DocVersionList,
    },
  };
</script>
